import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';


function Header() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="sticky top-0 bg-white/95 backdrop-blur-sm z-40">
      <div className="max-w-7xl mx-auto px-4 h-16 flex justify-between items-center">
        <div 
          className="flex items-baseline cursor-pointer"
          onClick={() => navigate('/')}
        >
          <img 
            src="/moolmit-logo2.svg" 
            alt="MOOLMIT" 
            className="h-6"
          />
          <span className="text-xl md:block hidden ml-2 font-big-john text-moolmit">
            Tattoo
          </span>
        </div>

        <div className="md:hidden relative">
          <button onClick={toggleMenu} className="focus:outline-none">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={3} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          {isMenuOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white/100 border border-gray-200 rounded-md shadow-lg z-50">
              <button 
                className="block w-full text-left px-4 py-2 text-gray-700 hover:text-gray-900 transition-colors"
                onClick={() => { navigate('/designs'); toggleMenu(); }}
              >
                Designs
              </button>
              <button 
                className="block w-full text-left px-4 py-2 text-gray-700 hover:text-gray-900 transition-colors"
                onClick={() => { navigate('/info'); toggleMenu(); }}
              >
                Info
              </button>
              {/* <button 
                className="block w-full text-left px-4 py-2 text-gray-700 hover:text-gray-900 transition-colors"
                onClick={() => { navigate('/booking'); toggleMenu(); }}
              >
                Booking
              </button> */}
              <button 
                className="block w-full text-left px-4 py-2 text-gray-700 hover:text-gray-900 transition-colors"
                onClick={() => { navigate('/about'); toggleMenu(); }}
              >
                About
              </button>
              <a
                href="https://www.instagram.com/moolmit.tattoo/"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-left px-4 py-2 text-gray-700 hover:text-gray-900 transition-colors"
              >
                Instagram
              </a>
            </div>
          )}
        </div>

        <nav className="hidden md:flex gap-4 items-center">
          <button 
            className="px-4 py-2 text-gray-700 hover:text-gray-900 transition-colors"
            onClick={() => navigate('/designs')}
          >
            Designs
          </button>
          <button 
            className="px-4 py-2 text-gray-700 hover:text-gray-900 transition-colors"
            onClick={() => navigate('/info')}
          >
            Info
          </button>
          {/* <button 
            className="px-4 py-2 text-gray-700 hover:text-gray-900 transition-colors"
            onClick={() => navigate('/booking')}
          >
            Booking
          </button> */}
          <button 
            className="px-4 py-2 text-gray-700 hover:text-gray-900 transition-colors"
            onClick={() => navigate('/about')}
          >
            About
          </button>
          <a
            href="https://www.instagram.com/moolmit.tattoo/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 hover:text-gray-900 transition-colors"
          >
            <FontAwesomeIcon icon={faInstagram} size="lg" />
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;